export default __webpack_public_path__ + "static/media/blackPin.3e0472da.svg";